import NoMatchPaaSRoute from './NoMatchPaaSRoute';

export default NoMatchPaaSRoute;
